import type { ClassData } from '@/core/types/library.type'

export function classFqn(classData: ClassData): string {
  return `${classData.namespace}.${classData.name}`
}
